import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/api'; // Tu instancia de Axios configurada
import styles from './VerificarCorreo.module.css'; // (Opcional) Estilo propio

const VerificarCorreo = () => {
  const [params] = useSearchParams();
  const [estado, setEstado] = useState('verificando'); // verificando | éxito | error

  useEffect(() => {
    const token = params.get('token');

    const verificar = async () => {
      try {
        const { data } = await api.get(`/verify_email?token=${token}`);

        setEstado('éxito');
      } catch (err) {

        setEstado('error');
      }
    };

    if (token) {
      verificar();
    } else {
      setEstado('error');
    }
  }, [params]);

  return (
    <div className={styles.contenedor}>
      {estado === 'verificando' && <p>Verificando tu correo electrónico...</p>}
      {estado === 'éxito' && (
        <div className={styles.mensajeExito}>
          <h2>Correo verificado correctamente</h2>
          <p>Ya puedes iniciar sesión.</p>
        </div>
      )}
      {estado === 'error' && (
        <div className={styles.mensajeError}>
          <h2>Error al verificar el correo</h2>
          <p>El enlace puede ser inválido o haber expirado.</p>
        </div>
      )}
    </div>
  );
};

export default VerificarCorreo;
